export default "__VITE_ASSET__BzoWW7$d__$_?nuxt_component=async&nuxt_component_name=IconFooterCarrierPostAt&nuxt_component_export=default__"